import { render, staticRenderFns } from "./CoozzyArrowRightIcon.vue?vue&type=template&id=23c1cbaa&scoped=true"
import script from "./CoozzyArrowRightIcon.vue?vue&type=script&lang=js"
export * from "./CoozzyArrowRightIcon.vue?vue&type=script&lang=js"
import style0 from "./CoozzyArrowRightIcon.vue?vue&type=style&index=0&id=23c1cbaa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23c1cbaa",
  null
  
)

export default component.exports